// src/modules/app-views/_apps/appmulti/plans/pages/Document/tabs/ParametersTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Row, Col } from 'antd';
import SimpleNumber from 'components/SimpleComponents/SimpleNumber';
import translateX from 'utils/translateX';
import { useDocumentContext } from 'components/core/DocumentProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ParametersTab = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data } = useDocumentContext();
  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      {/* Values */}
      <Card title={translateX('values')} style={{ marginBottom: 16 }}>
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <SimpleNumber
              name="markdown"
              label="markdown"
              min={0}
              max={100}
              decimalPlaces={2}
              percentage
            />
          </Col>
          <Col xs={24} sm={12}>
            <SimpleNumber
              name="discount"
              label="discount"
              min={0}
              max={100}
              decimalPlaces={2}
              percentage
            />
          </Col>
        </Row>
      </Card>

    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ParametersTab;
